import { render, staticRenderFns } from "./ActForm.vue?vue&type=template&id=79f9ccd2"
import script from "./ActForm.vue?vue&type=script&lang=js"
export * from "./ActForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports